import { DateRangeSelector } from "@/components/form-control/DateRangeSelector";
import { useContext } from "react";
import { FinanceFilter, FinanceFilterContext } from "@/modules/finance/helper/context/finance-filter.context";

export const FinanceFilters = () => {
  const { startDate, endDate, setRange } = useContext(FinanceFilterContext) as FinanceFilter;

  return (
    <>
      <DateRangeSelector
        variant="secondary"
        className="h-9"
        from={startDate}
        onChangeValue={(newDateRange) => {
          if (newDateRange.endDate && newDateRange.startDate) {
            setRange({ startDate: newDateRange.startDate, endDate: newDateRange.endDate });
          }
        }}
        to={endDate}
        maxDate={new Date()}
      />
    </>
  );
};
